import { useState, useEffect } from 'react';
import { BpmService } from '../../../../core/services/BpmService';



interface Props {
    idSelector: number;
    onChange: any;
    titulo: string;
    _idDocument: number;
}

export const SelectorResponseValueForDocument = ({ titulo, idSelector, onChange, _idDocument }: Props) => {

    const service = new BpmService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(undefined);

    useEffect(() => {
        getLista();
        setID(idSelector)
    }, [idSelector, _idDocument])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e))
    }

    const getLista = () => {
        service.getResponseValueForDocument(_idDocument).subscribe(
            (resp: any) => {
                setLista([]);
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
               //console.log("DataAcces", lista);
            }
        );
    }

    return (
        <>
            <label>{titulo}</label>
            <select className="form-control" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <>
                                <option key={index} value={item.DataBeanProperties.IDResponseValue} >
                                    {item.DataBeanProperties.IDForm}-{item.DataBeanProperties.Name}
                                </option>
                            </>)
                    })
                }
            </select>
        </>
    )
}